export default __webpack_public_path__ + "static/media/q7_step3.6b992dd3.png";